import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js'
import { Field, Form, Formik } from 'formik';
import React, { act, useEffect, useState } from 'react'
import { completePayment, verifyDiscount } from '../../services';
import { images } from '../../assets/images';
import { Dialog } from '@mui/material';
import { Link } from 'react-router-dom';
import styled from "@emotion/styled"
import * as Yup from "yup";


const BASE_PRICE = 300;

function Discount() {
    const [finalPrice, setFinalPrice] = useState(BASE_PRICE);
    const [requiresPayment, setRequiresPayment] = useState(true);
    const [error, setError] = useState('');
    const [initialValues, setInitialValues] = useState({
        discountCode: ''
    });
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    // const initialOptions = {
    //     clientId: "AYz7LpsqS6_eNEA8Nay9IttfACdJiNAbHEzx1JNr9H_Pn5Js_3ko_IhfZDnH-CmUjjPtP6jfVxISJnms"
    // }

    const initialOptions = {
        clientId: "AS8z0f0omVEGYQZisWbvZN2fe9hXhGCe11dCThZzPYcx0KdhZeqNwGqwDrgFd_nWSviext1f-VFPb_IC"
    }

    const PaymentDialog = styled(Dialog)`
        .MuiPaper-root {
        background-color: #FCE816;
        padding: 2em;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    `

    const handleSubmit = async (values) => {
        verifyDiscount(values).then(response => {
            if (response.status === 200) {
                setError('')
            }
            const discount = Number(response.data.discount);
            if (!Number.isFinite(discount) || discount < 0 || discount > 100) {
                throw new Error('Invalid discount received.');
            }
            const discountedPrice = Math.max(
                0,
                BASE_PRICE - (BASE_PRICE * discount / 100)
            );
            setFinalPrice(discountedPrice);
            setRequiresPayment(discountedPrice > 0);
            console.log(response);
        }).catch(err => {
            setFinalPrice(BASE_PRICE);
            setRequiresPayment(true);

            if (err.response?.status === 400) {
                setError(err.response.data.message);
            } else if (err.message === 'Invalid discount received.') {
                setError('Invalid discount.');
            } else {
                setError('Something went wrong.');
            }
        })
    };

    const handleFreeOrder = async () => {
        try {
            await completePayment(true);
            setIsDialogOpen(true);
        } catch (err) {
            console.error(err);
            setError('Something went wrong with your order')
        }
    }

    const handlePayPalApproval = async (data, actions) => {
        const details = await actions.order.capture();
        console.log('PayPal payment captured:', details);

        await completePayment(1);

        setIsDialogOpen(true);
    }

    const DiscountSchema = Yup.object().shape({
        discountCode: Yup.string().required("Required"),
    })

    return (
        <main className='checkout'>
            <header className="login__header">
                <a href="https://skinsagency.com">
                    <img src={images.logo} alt="logo" />
                </a>
            </header>
            <h1>Your Order</h1>
            <section>
                <article className='discount'>
                    <h2>Do you have a discount code?</h2>
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        onSubmit={handleSubmit}
                        validationSchema={DiscountSchema}
                    >
                        {({ errors, touched }) => (
                            <Form className='flex items-start gap-8 relative'>
                                <div className='flex flex-col gap-4'>
                                    <Field
                                        name="discountCode"
                                        placeholder="Enter Discount Code"
                                        className="has-border-bottom"
                                    />
                                    {errors.discountCode && touched.discountCode ? (
                                        <p className="has-red-text w-full text-xs mt-1">{errors.discountCode}</p>
                                    ) : null}
                                </div>
                                <button className='btn yellow-cta' type='submit'>Apply Discount</button>
                                {error && <p style={{ color: 'red', position: 'absolute', bottom: "-24px" }}>{error}</p>}
                            </Form>
                        )}
                    </Formik>
                    <p>Final Price: ${finalPrice.toFixed(2)}</p>
                </article>
                <article>
                    {requiresPayment && (<h2>Choose Payment Method</h2>)}
                    {requiresPayment ? (
                        <PayPalScriptProvider options={initialOptions}>
                            <PayPalButtons
                                key={finalPrice}
                                createOrder={(data, actions) => {
                                    return actions.order.create({
                                        purchase_units: [
                                            {
                                                amount: {
                                                    value: finalPrice.toString()
                                                }
                                            }
                                        ]
                                    })
                                }}
                                onApprove={handlePayPalApproval} />
                        </PayPalScriptProvider>
                    ) : (
                        <button className='btn yellow-cta' onClick={handleFreeOrder}>
                            Complete Order
                        </button>
                    )}
                </article>
            </section>
            <PaymentDialog open={isDialogOpen}>
                <h2 style={{ fontSize: "2.5em" }}>Order Complete</h2>
                <div className="welcome-cta">
                    <Link to={"/flow/purpose/passion"}>
                        <span style={{ color: 'black', fontSize: "1rem" }}>
                            Continue with the questionnaire.
                            <svg xmlns="http://www.w3.org/2000/svg" style={{maxWidth: "50px"}} width="198" height="198" viewBox="0 0 198 198">
                                <g transform="translate(-489 -763)">
                                    <g transform="translate(489 763)" fill="none" stroke="#000000" strokeWidth="5">
                                        <circle cx="99" cy="99" r="99" stroke="none" />
                                        <circle cx="99" cy="99" r="96.5" fill="none" />
                                    </g>
                                    <g transform="translate(-47.5 929.216) rotate(-90)">
                                        <line y2="73.093" transform="translate(66.858 597.5)" fill="none" stroke="#000000" strokeLinecap="round" strokeWidth="5" />
                                        <line x1="39.358" y2="39.358" transform="translate(66.858 634.984)" fill="none" stroke="#000000" strokeLinecap="round" strokeWidth="5" />
                                        <line x2="39.358" y2="39.358" transform="translate(27.5 634.984)" fill="none" stroke="#000000" strokeLinecap="round" strokeWidth="5" />
                                    </g>
                                </g>
                            </svg>
                        </span>
                    </Link>
                </div>
            </PaymentDialog>
        </main>
    )
}

export default Discount